import processInfo from "./data/processInfo";
import {
  type CheckoutInterruptedEvent,
  CheckoutInterruptedType,
  ProcessInfoName,
  ProcessStepSubStep,
} from "./types/types";

export const createCheckoutInterruptedEvent = (
  status: number | undefined,
): CheckoutInterruptedEvent => {
  const type = mapStatusToType(status);
  const name = mapStatusToName(status);
  const subStep = mapStatusToSubStep(status);
  return {
    event: "Checkout Interrupted",
    type,
    processInfo: processInfo.getProcessInfo("error", name, subStep),
  };
};

const mapStatusToType = (
  status: number | undefined,
): CheckoutInterruptedType => {
  switch (status) {
    case 1:
      return CheckoutInterruptedType.ErrorPageSsnIncorrectLoad;
    case 2:
      return CheckoutInterruptedType.ErrorPageBadCreditLoad;
    default:
      return CheckoutInterruptedType.ErrorPageUnknown;
  }
};

const mapStatusToName = (status: number | undefined): ProcessInfoName => {
  switch (status) {
    case 1:
      return ProcessInfoName.SsnIncorrect;
    case 2:
      return ProcessInfoName.BadCredit;
    default:
      return ProcessInfoName.webshop;
  }
};

const mapStatusToSubStep = (
  status: number | undefined,
): ProcessStepSubStep | undefined => {
  switch (status) {
    case 1:
      return ProcessStepSubStep.SsnIncorrect;
    case 2:
      return ProcessStepSubStep.BadCredit;
    default:
      return undefined;
  }
};
